import { AgentApiClient } from '@iconik-io/shared-lib/src/agent/agent_api_client';
import { axiosTransport } from '@iconik-io/shared-lib/src/agent/axios_transport';

export const agentApiClient = new AgentApiClient(axiosTransport);
